<template>
  <div>
    <div>
      <aha-modal @hide="hide()" :title="title_DeleteConfirmation">
        <div v-if="deletedPresentations.length === 1">
          <div>
            {{ $i18nPresenter.t("Are you sure you want to delete this presentation:") }}
            <span class="font-bold -mr-0.5">
              {{ deletedPresentations[0].name }} [{{ deletedPresentations[0].accessCode }}]
            </span>?
          </div>
        </div>
        <div class="max-h-52" v-else>
          <span>{{ $i18nPresenter.t("Are you sure you want to delete these presentations:") }}</span>
          <ul class="mt-2 ml-4 list-disc">
            <li
              class="mt-1"
              :key="presentation.id"
              v-for="presentation in deletedPresentations"
            >
              {{ presentation.name }} [{{ presentation.accessCode }}]
            </li>
          </ul>
        </div>

        <template #action>
          <aha-button
            variant="danger"
            :disabled="deletingPresentations"
            @click="handleDeletePresentations()"
            icon-name="delete"
            :submitting="deletingPresentations"
            has-margin-right
          >
            <aha-spinner variant="white" class="mr-1" v-if="deletingPresentations" />
            {{ $i18nPresenter.t("Delete") }}
          </aha-button>

          <aha-link @click="hide()">
            <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
          </aha-link>
        </template>
      </aha-modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

// api
import PresentationApi from '@/api/presentation'

// constants
import eventCategories from '@/constant/eventCategories'

// utils
import utils from '@/util'

// eventbus
import EventBus from '@/eventBus'

export default {
  props: {
    deletedPresentations: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deletingPresentations: false,
      title_DeleteConfirmation: this.$i18nPresenter.t('Delete confirmation'),
    }
  },
  computed: {
    ...mapState({
      presentations: (state) => state.presentations,
    }),
  },
  methods: {
    ...mapActions(['setPresentationsAction', 'setErrorOnInternalServerAction']),
    async handleDeletePresentations() {
      this.deletingPresentations = true
      const deletedPresentationIds = this.deletedPresentations
        .map((presentation) => presentation.id)

      try {
        await PresentationApi.deletePresentations(deletedPresentationIds)

        if (this.deletedPresentations.length === 1) {
          utils.showToastSuccess(`${this.$i18nPresenter.t('Deleted presentation')} "${this.deletedPresentations[0].name}"`)
        } else {
          utils.showToastSuccess(`${this.$i18nPresenter.t('Deleted')} ${this.deletedPresentations.length} ${this.$i18nPresenter.t('presentations')}`)
        }

        EventBus.$emit('reload-presentations-and-folders')

        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation > Delete > Succeeded')
      } catch (error) {
        if (this.deletedPresentations.length === 1 && this.deletedPresentations[0]) {
          this.setErrorOnInternalServerAction(`Cannot delete presentation ${this.deletedPresentations[0].name}`)
        } else {
          this.setErrorOnInternalServerAction(`Cannot delete ${this.deletedPresentations.length} presentations`)
        }

        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentation > Delete > Failed')
        throw error
      } finally {
        this.deletingPresentations = false
        this.hide()
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
